

 
 
import moment from 'moment'
import { React, useEffect, useState, Fragment, useCallback, useRef, useMemo, useContext } from "react";

import cogoToast from "cogo-toast";
import { SUCCESS_RESULT, TEMPLATES_URL, ENDPOINTS, LOCAL_PARAMS } from "../../Constants";
import { getTemplateByName, genericPost, genericGet } from "../../services/Api";
import { EbmsLoading, localizeData, getLocalizeData, resetLocalizeData, isObjectEmpty, log, getUniqueString } from "../../services/Utils";

import { useHistory, Link, useParams } from "react-router-dom";
import { Breadcrumb, BreadcrumbItem, Table, Button } from "reactstrap";
// import * as d3 from "d3";
import "./style.css";
import * as FaIcons from 'react-icons/fa';
import * as SurveyCore from "survey-core";
import { Survey } from 'survey-react-ui';
import "survey-core/defaultV2.css";
import "survey-creator-core/survey-creator-core.min.css";
import { AgGridReact } from "ag-grid-react";
import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-alpine.css";
import { FaTimes, FaEdit, FaPlus, FaEye, FaArrowAltCircleRight } from "react-icons/fa";
import { getDb as myDb } from '../../services/DbHelper';
import { useLiveQuery } from "dexie-react-hooks";
import AppContext from "../../AppContext";

SurveyCore.StylesManager.applyTheme("defaultV2");




const OngoingSurveys = () => {
    const global = useContext(AppContext);
    const [isLoading, setIsLoading] = useState(false);
    const [allActiveSurveys, setAllActiveSurveys] = useState([]);
    const history = useHistory();
    const gridRef = useRef();
    const [gridApi, setGridApi] = useState(null);
    let db = myDb();
    // let allSurveys=[];


    
    const allSurveys = useLiveQuery(() => db.transaction('r', [db.surveys, db.submissions], async () => {
        //   const austin = await db.friends.get({firstName: "Austin", lastName: "Powers"});
        // Query by "foreign key" on vehicles:
        let allLocalSurveys = await db.surveys.toArray();
        // return allLocalSurveys;
        // log("SURVEY:: ", allLocalSurveys.length);
        if (allLocalSurveys.length > 0) {
            for (let q = 0; q < allLocalSurveys.length; q++) {
                let suvy = allLocalSurveys[q];
                // log("SURVEY:: ", suvy['token']);
                let submissionTotalCount = await db.submissions.where({ token: suvy['token'] }).toArray();
                let submissionUploadedCount = await db.submissions.where({ token: suvy['token'], sync_status: "10001" }).toArray();
                log("submissionTotalCount", submissionTotalCount);
                // allLocalSurveys[q]['total_count']=submissionTotalCount;
                // allLocalSurveys[q]['total_uploaded_count']=submissionUploadedCount;
                if (submissionUploadedCount === null || submissionUploadedCount === undefined)
                    submissionUploadedCount = 0;
                else
                    submissionUploadedCount = submissionUploadedCount.length;
                if (submissionTotalCount === null || submissionTotalCount === undefined)
                    submissionTotalCount = 0;
                else
                    submissionTotalCount = submissionTotalCount.length;
                allLocalSurveys[q]['uploaded_total'] = submissionUploadedCount + "/" + submissionTotalCount;
                // allLocalSurveys[q]['uploaded_total'] =  "25/45";
            }
        }

        return allLocalSurveys;
    }) /*db.surveys.toArray()*/,);


     
    useEffect(() => {
        document.title = "Invited to complete your survey.";
        // loadActiveSurveys();
        getSurveys();
        setAllActiveSurveys(allSurveys);
        // log("allActiveSurveys", allActiveSurveys);
        // updateUser();

    }, []);
   
    function getSurveys() {
        return db.transaction('r', [db.surveys, db.submissions], async () => {
            //   const austin = await db.friends.get({firstName: "Austin", lastName: "Powers"});
            // Query by "foreign key" on vehicles:
            const allLocalSurveys = await db.surveys.toArray();
            // log("SURVEY:: ", allLocalSurveys.length);
            let allLocalSurveysInfo = [];
            if (allLocalSurveys.length > 0) {
                for (let q = 0; q < allLocalSurveys.length; q++) {
                    let suvy = allLocalSurveys[q];
              
                    allLocalSurveys[q]['uploaded_total'] = "25/45";
                    allLocalSurveysInfo[q] = allLocalSurveys;


                }
            }
            log("SURVEY:: ", allLocalSurveys);
       
            allSurveys = allLocalSurveysInfo;
            setAllActiveSurveys(allSurveys);
         
            return allLocalSurveysInfo;
        });
    }
    const addUserToOfflineDb = async () => {
        db.transaction('rw', db.user, async function () {
            let userData = global.get_logged_in_user();
            if (userData == null) {
                history.push({
                    pathname: "/",
                    // state: data,
                });
                return;
            } else {
                await db.user.clear().then(() => {
                    // log("SAVING","CLEARED THE TABLE");
                });
                db.user.add({
                    user_id: userData["id"],
                    usertoken: userData["usertoken"],
                    details: userData
                });
                log("User Addition Success: ", userData);
            }
        }).catch(function (e) {
            // console.error(e.stack);
            log("User Error: ", e.stack);
        });
    };
    const addSurveysToOfflineDb = async (activeSurveys) => {
        db.transaction('rw', db.surveys, async function () {
            if (activeSurveys.length > 0) {
                await db.surveys.clear().then(() => {
                    // log("SAVING","CLEARED THE TABLE");
                });
                for (let a = 0; a < activeSurveys.length; a++) {
                    let survey = activeSurveys[a];
                    let surveyToCreateUpdate = {
                        survey_id: survey['survey_id'],
                        token: survey['token'],
                        name: survey['name'],
                        location: survey['location'],
                        country: survey['country'],
                        questionnaire: survey['questionnaire'],
                        description: survey['description'],
                        startdate: survey['startdate'],
                        enddate: survey['enddate'],
                        project_id: survey['project_id'],
                        status: survey['status'],
                        version: survey['version'],
                        live_status: survey['live_status'],
                        created_at: (new Date()),
                        updated_at: (new Date())
                    };
                    db.surveys.add(surveyToCreateUpdate);
                    // let surveyInst = 0;
                    // await db.surveys.where({ survey_id: survey['survey_id'] }).count().then((total) => {
                    //     log("SAVING22", total + "<<dd");
                    // });
                    // //where("survey_id").equals(survey['survey_id']).count();//.toArray();

                    // if (surveyInst > 0) {
                    //     let id = surveyInst[0].id;
                    //     log("SAVING", "Updated the record id: " + id + "<<>>" + survey['survey_id']);
                    //     db.surveys.update(id, surveyToCreateUpdate);
                    //     // surveyInst.modify(surveyToCreateUpdate);
                    // } else {
                    //     log("SAVING", "Created the record id: " + survey['survey_id']);
                    //     db.surveys.add(surveyToCreateUpdate);
                    // }

                    // log("SurveyItem Updated", "Updated");
                }
            }
        }).catch(function (e) {
            // console.error(e.stack);
            log("SurveyItem Error: ", e.stack);
        });
        // event.preventDefault()
        // for (let a = 0; a < surveys.length; a++) {
        //     let survey = surveys[a];

        //             survey['created_at'] = new Date();
        //             survey['updated_at'] = new Date();
        //             let timestamp = new Date();
        //             log("SurveyItem", survey);
        //             await db.surveys.put({
        //                 survey_id: survey['survey_id'],
        //                 token: survey['token'],
        //                 name: survey['name'],
        //                 location: survey['location'],
        //                 country: survey['country'],
        //                 questionnaire: survey['questionnaire'],
        //                 description: survey['description'],
        //                 startdate: survey['startdate'],
        //                 enddate: survey['enddate'],
        //                 project_id: survey['project_id'],
        //                 status: survey['status'],
        //                 version: survey['version'],
        //                 live_status: survey['live_status'],
        //                 created_at:timestamp,
        //                 updated_at:timestamp
        //             });
        //             // .then((value) => {
        //             //    
        //             // });
        //  log("SurveyItem Updated", "Updated");
        // }
    }
    //DATA TO SYNC ONLINE AND OFFLINE
    const syncSubmissionOnline = async () => {

        // log("localSubbmissionsNotSynced: ", "below");
        setIsLoading(true);
        db.transaction('rw', [db.submissions], async function () {
            let isEverythingSuccessful = true;
            let localSubbmissionsNotSynced = await db.submissions.where({ sync_status: "10000" }).toArray();
            // log("To Be Synced: ", localSubbmissionsNotSynced.length);
            if (localSubbmissionsNotSynced.length > 0) {
                // await db.submissions.clear().then(() => {
                //     log("submissions","CLEARED THE TABLE");
                // });
                for (let r = 0; r < localSubbmissionsNotSynced.length; r++) {
                    // for (let syncDatas of localSubbmissionsNotSynced) {
                    let syncData = localSubbmissionsNotSynced[r];//syncDatas;// 
                    // log("Sync Data", syncData);
                    genericPost(ENDPOINTS.POST_WEB_SURVEY_RESPONSES, syncData)
                        .then(async (res) => {
                            if (res.status == 200) {
                                console.clear();
                                log("RESPONSE::: ", res.data);
                                if (res.data.status == SUCCESS_RESULT) {
                                    log("RES: ", "Successful")
                                    let syncToken = (res.data.data)["sync_token"];
                                    log("syncToken", syncToken);
                           




                                    const objectStore = await db.submissions.where({ sync_token: syncToken  });
                                 
                                    setTimeout(() => {
                                        objectStore.modify({ sync_status: "10001" })
                                    }, 1000);
                                    
                                } else {
                                    log("RES: ", "Not Successful")

                                    isEverythingSuccessful = false;
                             
                                }
                            } else {
                                isEverythingSuccessful = false;
                                // cogoToast.error("Connection error. Please try again.", {});
                            }
                            setIsLoading(false);
                        })
                        .catch((err) => {
                            isEverythingSuccessful = false;
                            setIsLoading(false);
                            // cogoToast.error("Critical error occurred. Please try again.", {});
                        });
                    // return await Promise.resolve(null);
                }
                
            } else {
                setIsLoading(false);
                cogoToast.success("All the local data has been uploaded.", {});
            }
        }).catch(function (e) {
            // console.error(e.stack);
            log("SurveyItem Error: ", e.stack);
            // cogoToast.error("Warning!! Your local synchronization is not successful.", {});

        });

    };
    const loadActiveSurveys = () => {

        setIsLoading(true);
        genericGet(ENDPOINTS.ACTIVE_SURVEYS, {})
            .then((res) => {
                if (res.status == 200) {
                    if (res.data.status == SUCCESS_RESULT) {

                        let rawData = res.data;
                        // log("RawData: ", rawData['data']);
                        if (!rawData['data']) {
                            cogoToast.error("You request was not successful. Please try again Please try again.", {});
                            setIsLoading(false);
                            return;
                        } else {
                            // setAllActiveSurveys(rawData['data']);
                            addSurveysToOfflineDb(rawData['data']);
                        }

                    } else {
                        cogoToast.error(res.data.message, {});
                    }
                } else {
                    cogoToast.error("Connection error. Please try again.", {});
                }
                setIsLoading(false);
            })
            .catch((err) => {
                // log("Error:: ");
                // log("err: ", err);
                setIsLoading(false);
                cogoToast.error("Server error, please try again", {});
            });
    };

    const defaultColDef = useMemo(() => {
        return {
            editable: false,
            sortable: true,
            flex: 1,
            minWidth: 100,
            filter: true,
            resizable: true,
        };
    }, []);
    return (
        <div>
            <Breadcrumb className="ms-1">
                <BreadcrumbItem>
                    <Link to="/ebms"> EBMS </Link>
                </BreadcrumbItem>
                <BreadcrumbItem>
                    <Link to="/ebms/surveys/list"> SURVEYS </Link>
                </BreadcrumbItem>
                <BreadcrumbItem active>
                    <Link to="/ebms/surveys/ongoing-surveys"> ONGOING SURVEYS </Link>
                </BreadcrumbItem>
            </Breadcrumb>
            <center><EbmsLoading data={isLoading} /></center>
            <div class="row">
                <div class="form-control">
                    <Button
                        className="btn btn-info pull-right btn-l"
                        onClick={() => {
                            // alert("How is it");

                            // updateDb();
                            // return;

                            loadActiveSurveys();
                            syncSubmissionOnline();
                            addUserToOfflineDb();
                            // setIsHidden(true);
                            // setSurveyModelData({});
                            // setSurveyModel(new SurveyCore.Model(params["questionnaire"]));
                        }}
                    >
                        +&nbsp; Sync Survey Data
                    </Button>
                </div>
            </div>
            <div class="row">
                <div className="ag-theme-alpine">
                    <AgGridReact
                        suppressMenuHide={true}

                        ref={gridRef}
                        overlayLoadingTemplate={
                            '<div class="card-body text-end placeholder-glow"> <div class="placeholder col-9 mb-3"></div><div class="placeholder placeholder-xs col-10"></div><div class="placeholder placeholder-xs col-12"></div><div class="placeholder placeholder-xs col-11"></div> <div class="placeholder placeholder-xs col-8"></div><div class="placeholder placeholder-xs col-10"></div></div>'
                        }
                        onGridReady={(params) => {
                            setGridApi(params.api);
                            params.api.showLoadingOverlay();
                        }}
                        rowData={allSurveys}
                        domLayout={"autoHeight"}
                        animateRows={true}
                        pagination={true}
                        paginationPageSize={100}
                        defaultColDef={defaultColDef}
                        resizable={true}
                        enableCellTextSelection={true}
                        suppressCellSelection={true}
                        columnDefs={[
                            {
                                headerName: 'YOUR ACTIVE SURVEYS',

                                children: [
                                    {
                                        headerName: "#",
                                        filter: false,
                                        maxWidth: 70,
                                        sortable: true,
                                        valueFormatter: function (params) {
                                            return `${parseInt(params.node.id) + 1}`;
                                        },
                                    },
                                    {
                                        headerName: "Survey Name",
                                        field: "name",
                                        sortable: true,
                                        filter: true,
                                    }, {
                                        headerName: "Location ",
                                        field: "location",
                                        sortable: true,
                                        filter: true,

                                    }, {
                                        headerName: "Description",
                                        field: "description",
                                        sortable: true,
                                        filter: true,

                                    }
                                    , {
                                        headerName: "Start Date",
                                        field: "startdate",
                                        sortable: true,
                                        filter: true,
                                    }

                                    , {
                                        headerName: "End Date",
                                        field: "enddate",
                                        sortable: true,
                                        filter: true,

                                    },
                                    {
                                        headerName: "Version",
                                        field: "version",
                                        sortable: true,
                                        filter: true,
                                    },
                                    {
                                        headerName: "Mode",
                                        field: "action",
                                        width: 100,
                                        sortable: false,
                                        filter: false,
                                        //suppressMovable: true,
                                        cellRendererFramework: (e) => {
                                            let data = e.data;
                                            let live_status = data["live_status"];

                                            return (
                                                live_status == SUCCESS_RESULT ? <span class="badge bg-green-lt">Live</span> : <span class="badge bg-red-lt">Staging</span>
                                            );
                                        }
                                    },
                                    {
                                        headerName: "Submissions (uploaded/Total)",
                                        field: "uploaded_total",
                                        sortable: true,
                                        filter: true,

                                    },
                                    {
                                        headerName: "Action",
                                        field: "action",
                                        width: 100,
                                        sortable: false,
                                        filter: false,
                                        //suppressMovable: true,
                                        cellRendererFramework: (e) => {
                                            // console.log("EEEEEE");
                                            // console.log(e);
                                            return (
                                                <span>
                                                    <span onClick={() => { }} className="level-top">
                                                        <FaArrowAltCircleRight
                                                            style={{
                                                                color: "#305176",
                                                                cursor: "pointer",
                                                                fontSize: "1.5em"
                                                            }}
                                                            onClick={() => {
                                                                let data = e.data;
                                                                history.push({
                                                                    pathname: "/ebms/surveys/ongoing/inline-web-survey/" + data["token"],
                                                                    // state: data,
                                                                });
                                                            }}
                                                        />
                                                    </span>
                                                </span>
                                            );
                                        }
                                    }
                                ]
                            }]}
                    ></AgGridReact>
                </div>
            </div>
        </div>
    );
};

export default OngoingSurveys;

